'use client';
// Marks <html> with `data-native-app` inside the Auctogon Admin phone app, so globals.css can
// scope the app-only touch rules (no long-press text selection, image or link menus, tap flash:
// BUG-2164) without touching a browser tab. Mounted once in the root layout; renders nothing.
import { useEffect } from 'react';

import { useIsNativeApp } from '../../hooks/useIsNativeApp';

/** The attribute globals.css keys the app-only touch rules on. */
const NATIVE_APP_ATTRIBUTE = 'data-native-app';

/**
 * Sets the native-app marker on the document root while the native-device gateway says the page
 * runs in the app (ADR 064 — Native Shell § 5), and removes it on unmount.
 * @returns nothing (renders no UI).
 * @sideEffect Sets or removes the `data-native-app` attribute on `document.documentElement`.
 */
export function NativeAppMarker(): null {
  const { isNativeApp } = useIsNativeApp();

  useEffect(() => {
    if (!isNativeApp) return;
    const root = document.documentElement;
    root.setAttribute(NATIVE_APP_ATTRIBUTE, '');
    return () => root.removeAttribute(NATIVE_APP_ATTRIBUTE);
  }, [isNativeApp]);

  return null;
}
